import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EMAIL_OPENFORGE, OPENFORGE_WEBSITE_URL } from '@app/config';
import { TuiButton } from '@taiga-ui/core';
import { RoughNotationModule } from 'ng-rough-notation';

@Component({
  selector: 'app-partners-openforge-hero-section',
  imports: [RoughNotationModule, TuiButton],
  templateUrl: './partners-openforge-hero-section.component.html',
  styleUrl: './partners-openforge-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersOpenforgeHeroSectionComponent {
  protected readonly openForgeWebsite = OPENFORGE_WEBSITE_URL;
  protected readonly emailOpenforge = EMAIL_OPENFORGE;
}
